import React, { useState } from 'react';
import genStyles from '../generale.module.css';
import ReactDOM from 'react-dom';
import { DropdownSelect } from '../dropdownSelect';
import DrawService from '../../service/DrawService';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { apiCollectionState, localDataState, toastState, userDataState } from '../../atoms/CollectionState';
import CollectionService from '../../service/CollectionService';

export default function SetStyleForm({ onClose, setbModifStyleForm, objectCur, setEntites, popoverStyle, saveaction }) {

    const LocalData = useRecoilValue(localDataState);
    const api_collection = useRecoilValue(apiCollectionState);
    const user_data = useRecoilValue(userDataState);     
    const setToast = useSetRecoilState(toastState); 
    
    const [form, setForm] = useState({
        polycontourColor : '',
        polycontourOpacity: '',
        polycontourEpaisseur : '',
        polyColor:'',
        polyOpacity:''
    });

    const isDisabled = Object.values(form).every(value => value === '' || value === 0 || value === null);

    const presetColors = [
        { name: "#36c980", iconClass: "#36c980" },
        { name: "#a0d44f", iconClass: "#a0d44f" },
        { name: "#c9b957", iconClass: "#c9b957" },
        { name: "#face47", iconClass: "#face47" },
        { name: "#7945ca", iconClass: "#7945ca" },
        { name: "#a15bd5", iconClass: "#a15bd5" },
        { name: "#6499f4", iconClass: "#6499f4" },
        { name: "#76cbf9", iconClass: "#76cbf9" },
        { name: "#b63453", iconClass: "#b63453" },
        { name: "#db465e", iconClass: "#db465e" },
        { name: "#f61e87", iconClass: "#f61e87" },
        { name: "#f75cbf", iconClass: "#f75cbf" },
        { name: "#f7683c", iconClass: "#f7683c" },
        { name: "#f7af54", iconClass: "#f7af54" },
        { name: "#7d5247", iconClass: "#7d5247" },
        { name: "#818181", iconClass: "#818181" },
        { name: "#252525", iconClass: "#252525" },
        { name: "#FFFFFF", iconClass: "#FFFFFF" },
    ];


    const saveStyle = () => {
        objectCur.forEach((entity) => {
            DrawService.updateStyleLayer(form, entity.id,entity.type);
            setEntites((prevList) => {
                const updatedList = prevList.map((entityup) => {
                    if (entityup.id === entity.id) {
                        const updatedGeoJSON = entity.geojson;
                        if(entityup.type === 'marker'){
                            if (form.polyColor) {
                                updatedGeoJSON.properties.options.icon.options.markerColor = form.polyColor;
                            }
                        }else if(entityup.type === 'textMarker'){
                            if (form.polyColor) {
                                updatedGeoJSON.properties.css.color = form.polyColor;
                            }
                        }else if(entityup.type === 'polyline'){
                            if (form.polycontourColor) {
                                updatedGeoJSON.properties.options.color = form.polycontourColor;
                            }
                            if (form.polycontourOpacity) {
                                updatedGeoJSON.properties.options.opacity = form.polycontourOpacity;
                            }
                            if (form.polycontourEpaisseur && form.polycontourEpaisseur != 0) {
                                updatedGeoJSON.properties.options.weight = form.polycontourEpaisseur;
                            }
                        }else if( entityup.type === 'polygon' || entityup.type === 'circle' || entityup.type === 'rectangle'){                            
                            if (form.polycontourColor) {
                                updatedGeoJSON.properties.options.color = form.polycontourColor;
                            }
                            if (form.polycontourOpacity) {
                                updatedGeoJSON.properties.options.opacity = form.polycontourOpacity;
                            }
                            if (form.polycontourEpaisseur && form.polycontourEpaisseur != 0) {
                                updatedGeoJSON.properties.options.weight = form.polycontourEpaisseur;
                            }
                            if (form.polyColor) {
                                updatedGeoJSON.properties.options.fillColor = form.polyColor;
                            }
                            if (form.polyOpacity) {
                                updatedGeoJSON.properties.options.fillOpacity = form.polyOpacity;
                            }
                        }
                        const updatedEntity = { 
                            ...entity, 
                            geojson: updatedGeoJSON,
                        };
                                    
                        if(saveaction === 'oui'){
                            saveBDStyle(updatedEntity)
                        }
                        return updatedEntity;
                    }
                    return entityup;
                });
                return updatedList;
            });

            
        });
         onClose();
    };

    const saveBDStyle = (currentEntite) => {  
        const idcollection = currentEntite.collection_id;
        const entite = {
          css :  (typeof currentEntite.geojson.properties.css === "string") ? currentEntite.geojson.properties.css : JSON.stringify(currentEntite.geojson.properties.css),
          geom :JSON.stringify(currentEntite.geojson.geometry),
          id : currentEntite?.idnewbd ?? currentEntite.geojson.properties.id,
          measure : currentEntite.geojson.properties.measure,
          afficher_centroide: currentEntite.geojson.properties.afficher_centroide,
          observation : currentEntite.geojson.properties.observation,
          options :  JSON.stringify(currentEntite.geojson.properties.options),
          tag : currentEntite.geojson.properties.tag,
          titre : currentEntite.geojson.properties.titre,
          type : currentEntite.geojson.properties.type
        };
        
        if(!LocalData){
          let api = api_collection+ user_data.account.port+ '/';
          let userId = user_data.user.id;
          CollectionService.updateEntite(api,userId,idcollection,entite).then((response) => {
            if(response.rows){
                setToast({ message: "Les entités sélectionnées ont été éditées" , type: 'success' }); 
            } else {
                setToast({ message: response.message , type: 'error' });
            } 
          });
        }        
  
    };

    const updateField = (key, value) => {
        setForm((prev) => {
            let updatedValue = value;

            // Si on modifie la transparence, convertir % en valeur 0-1
            if (key === "polycontourOpacity" || key === "polyOpacity") {
                const numericValue = parseFloat(value);
                if (!isNaN(numericValue)) {
                    updatedValue = numericValue / 100;
                } else {
                    updatedValue = 0;
                }
            }

            const updatedForm = { ...prev, [key]: updatedValue };
           
            objectCur.forEach((entity) => {
                DrawService.updateStyleLayer(updatedForm, entity.id,entity.type);
            });
            return updatedForm;
        });
    };

    const closeWithoutSave = () => {
        if(setbModifStyleForm){
            setbModifStyleForm(true);
        }
        onClose();
    }

    const popover = (
        <div
            style={{
                position: "absolute",
                top: popoverStyle.top,
                left: popoverStyle.left,
                zIndex: 2000,
                backgroundColor: "white",
                border: "1px solid #ccc",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
                padding: "10px",
                width: "450px"
            }}
        >
            <button
                onClick={closeWithoutSave}
                style={{
                    position: "absolute",
                    top: "10px",
                    right: "15px",
                    background: "transparent",
                    border: "none",
                    fontSize: "18px",
                    cursor: "pointer",
                    color: "#666",
                }}
                title="Fermer"
                >
                <i className="fa-solid fa-xmark"></i>
            </button> 
            <div className={genStyles.edsection} style={{marginBottom:'0px !important'}}>
                <div className={genStyles.titleedsection}>
                    <i className={`fa-solid fa-palette ${genStyles.fontSize18} ${genStyles.fontSize18} ${genStyles.icomargin}`}></i>
                    <span className={`${genStyles.fontSize16} ${genStyles.bold} ${genStyles.bgcolorfirsttext}`}>
                    Styles
                    </span>
                </div>
                <div className="row container_style mb10">
                    <div className="col s4">
                        <span className={`${genStyles.fontSize15}  ${genStyles.bgcolorfirsttext}  ${genStyles.noMargin}`}>Contour</span>
                        <div className={genStyles.pickctn}>
                            <DropdownSelect
                                options={presetColors}
                                selected={form.polycontourColor}
                                onChange={(color) => updateField("polycontourColor", color)}
                                type="color"
                                showCustomColor={true}
                            />                               
                            <input
                                className={genStyles.inputtCol}
                                type="text"
                                value={form.polycontourColor}
                                onChange={(e) => updateField("polycontourColor", e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="col s4">
                        <span className={`${genStyles.fontSize15}  ${genStyles.bgcolorfirsttext}  ${genStyles.noMargin}`}>Opacité</span>
                            <div className={genStyles.pickctn}>
                            <input
                                className={genStyles.inputtCol}
                                type="number"
                                min="0"
                                max="100"
                                value={form.polycontourOpacity !== '' ? (form.polycontourOpacity * 100).toFixed(0) : ''}
                                onChange={(e) => updateField("polycontourOpacity", e.target.value)}
                            />
                            <span> %</span>
                            </div>
                    </div>
                    <div className="col s4">
                        <span className={`${genStyles.fontSize15}  ${genStyles.bgcolorfirsttext}  ${genStyles.noMargin}`}>Épaisseur</span>
                        <input
                            className={genStyles.inputtCol}
                            type="number"
                            min="0"
                            value={form.polycontourEpaisseur}
                            onChange={(e) => updateField("polycontourEpaisseur", e.target.value)}
                        />
                    </div>
                </div>   
                <div className="row container_style mb10">
                    <div className="col s4">
                        <span className={`${genStyles.fontSize15}  ${genStyles.bgcolorfirsttext}  ${genStyles.noMargin}`}>Remplissage</span>
                        <div className={genStyles.pickctn}>
                            <DropdownSelect
                                options={presetColors}
                                selected={form.polyColor}
                                onChange={(color) => updateField("polyColor", color)}
                                type="color"
                                showCustomColor={true}
                            />                               
                            <input
                                className={genStyles.inputtCol}
                                type="text"
                                value={form.polyColor}
                                onChange={(e) => updateField("polyColor", e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="col s4">
                        <span className={`${genStyles.fontSize15}  ${genStyles.bgcolorfirsttext}  ${genStyles.noMargin}`}>Opacité</span>
                        <div className={genStyles.pickctn}>
                            <input
                                className={genStyles.inputtCol}
                                type="number"
                                min="0"
                                max="100"
                                value={form.polyOpacity !== '' ? (form.polyOpacity * 100).toFixed(0) : ''}
                                onChange={(e) => updateField("polyOpacity", e.target.value)}
                            />
                            <span> %</span>
                        </div>
                    </div>
                    <div className={`${genStyles.pickctn} col s4`} >
                        <button
                            className={`btn full_width uppercase ${genStyles.bgcolorfirst}`}
                            onClick={saveStyle}
                            disabled={isDisabled}
                            style={{
                                opacity: isDisabled ? 0.5 : 1,
                                cursor: isDisabled ? "not-allowed" : "pointer",
                                transition: "opacity 0.2s ease"
                            }}
                        >
                        Enregistrer
                        </button>
                    </div>
                </div>                  
            </div>

        </div>
    );

    return ReactDOM.createPortal(popover, document.body);
}
